import fetchApi from "../fetchApi";
export const getReplaceCardReceipt = async (
    {id}
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/${id}/replace/receipt`, options);
};